import addHours from "date-fns/addHours";

export default function getCookieExpiryTime(expireTime?: number): Date {
    const now = new Date()
    return addHours(now, expireTime ?? 24 * 365 * 10)
}